<script>
import EcConnectionService from "@/services/EcConnectionService";
import VConnConfig from "@/components/Costs/VConnConfig";
import VFilters from "@/components/Search/VFilters";
import {
    EcConnectionStatus,
    EcConnectionType
} from "@/constants/EcConnection.const";

export default {
    components: { VConnConfig, VFilters },
    data() {
        return {
            loading: true,
            conns: [],
            meta: {}
        };
    },
    computed: {
        optStatus() {
            return EcConnectionStatus;
        },
        optType() {
            return EcConnectionType;
        }
    },
    async created() {
        this.initSearch();
        await this.fetchData();
        this.$apiEnableWatcher();
        this.loading = false;
    },
    methods: {
        async fetchData() {
            try {
                let params = this.$buildParams();
                const { data } = await EcConnectionService.GET(params);
                this.conns = data.data;
                this.meta = data.meta;
            } catch (e) {
                console.log("fd e", e);
            }
        },
        initSearch() {
            this.apiSearchFilter = {
                search: "",
                connection_type: "",
                status: ""
            };
        }
    }
};
</script>

<template>
    <div>
        <base-header class="pb-1" type="">
            <bread-bag> </bread-bag>
        </base-header>

        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <v-filters
                        v-if="!loading"
                        :search="true"
                        v-model="apiSearchFilter.search"
                        :enable-filters="true"
                        @filter-view-change="$handleFilterView($event)"
                        @reset-search="initSearch"
                    >
                        <template slot="default">
                            <div class="col-4">
                                <FormulateInput
                                    v-model="apiSearchFilter.connection_type"
                                    :placeholder="
                                        $t('ec_connection.connection_type')
                                    "
                                    type="fselect"
                                    :options="optType"
                                />
                            </div>
                            <div class="col-4">
                                <FormulateInput
                                    v-model="apiSearchFilter.status"
                                    :placeholder="$t('ec_connection.status')"
                                    type="fselect"
                                    :options="optStatus"
                                />
                            </div>
                        </template>
                    </v-filters>
                    <v-loader :loading="loading" v-if="loading" />
                    <card body-classes="px-0" v-else-if="conns.length > 0">
                        <v-table class="table table-mg table-sm">
                            <v-thead>
                                <v-tr>
                                    <v-th
                                        ><v-sorter
                                            :paginator="apiPaginator"
                                            name="id"
                                            @sort="$handleSorting($event)"
                                            >{{
                                                $t("ec_connection.tbl_hdr_id")
                                            }}</v-sorter
                                        ></v-th
                                    >
                                    <v-th
                                        ><v-sorter
                                            :paginator="apiPaginator"
                                            name="Projects.title"
                                            @sort="$handleSorting($event)"
                                            >{{
                                                $t(
                                                    "ec_connection.tbl_hdr_project"
                                                )
                                            }}</v-sorter
                                        ></v-th
                                    >
                                    <v-th
                                        ><v-sorter
                                            :paginator="apiPaginator"
                                            name="status"
                                            @sort="$handleSorting($event)"
                                            >{{
                                                $t(
                                                    "ec_connection.tbl_hdr_status"
                                                )
                                            }}</v-sorter
                                        ></v-th
                                    >
                                    <v-th
                                        ><v-sorter
                                            :paginator="apiPaginator"
                                            name="valid_from"
                                            @sort="$handleSorting($event)"
                                            >{{
                                                $t(
                                                    "ec_connection.tbl_hdr_valid_from"
                                                )
                                            }}</v-sorter
                                        ></v-th
                                    >
                                    <v-th
                                        ><v-sorter
                                            :paginator="apiPaginator"
                                            name="connection_type"
                                            @sort="$handleSorting($event)"
                                            >{{
                                                $t(
                                                    "ec_connection.tbl_hdr_connection_type"
                                                )
                                            }}</v-sorter
                                        ></v-th
                                    >
                                    <v-th
                                        ><v-sorter
                                            :paginator="apiPaginator"
                                            name="last_sync_time"
                                            @sort="$handleSorting($event)"
                                            >{{
                                                $t(
                                                    "ec_connection.tbl_hdr_last_sync"
                                                )
                                            }}</v-sorter
                                        ></v-th
                                    >
                                    <v-th>{{
                                        $t(
                                            "ec_connection.tbl_hdr_account_numbers"
                                        )
                                    }}</v-th>
                                </v-tr>
                            </v-thead>
                            <v-tbody>
                                <v-tr v-for="c in conns" :key="c.id">
                                    <v-td>{{ c.id }}</v-td>
                                    <v-td
                                        ><router-link
                                            :to="{
                                                name: 'ProjectViewCostsInbox',
                                                params: {
                                                    project_id: c.project_id
                                                }
                                            }"
                                            >{{ c.project.title }}
                                            <div class="text-muted small">
                                                #{{ c.project.id }}
                                            </div>
                                        </router-link>
                                    </v-td>
                                    <v-td>{{ c.status_name }}</v-td>
                                    <v-td>{{ c.valid_from }}</v-td>
                                    <v-td
                                        >{{ c.connection_type_name }}
                                        <div class="small">
                                            {{ c.description }}
                                        </div>
                                    </v-td>
                                    <v-td
                                        ><template v-if="c.last_sync_time"
                                            >{{
                                                $d(
                                                    new Date(c.last_sync_time),
                                                    "long"
                                                )
                                            }}
                                        </template>
                                        <template v-else>---</template>
                                    </v-td>
                                    <v-td><v-conn-config :context="c"/></v-td>
                                </v-tr>
                            </v-tbody>
                        </v-table>
                        <div class="paginator">
                            <base-pagination
                                :page-count="meta.pagination.total_pages"
                                :per-page="meta.pagination.per_page"
                                :value="meta.pagination.current_page"
                                @input="$handlePagination($event)"
                            />
                        </div>
                    </card>
                    <div v-else class="alert alert-warning">wss</div>
                </div>
            </div>
        </div>
    </div>
</template>
